export enum TenancyStatus {
  DRAFT = 'DRAFT',
  INACTIVE = 'INACTIVE',
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
}

export interface RawTenancyApiResponse {
  id: string;
  placement_id: string;
  name: string | null;
  start: string;
  end: string;
  position: number;
  status: TenancyStatus;
  custom?: any;
  created_at: string;
  updated_at: string;
}

export interface RawTenancyApiCreateRequest {
  placement_id: string;
  name?: string;
  start: string;
  end: string;
  position: number;
  custom?: any;
}

export enum TenancyUpdateStatus {
  DRAFT = 'DRAFT',
  INACTIVE = 'INACTIVE',
  ACTIVE = 'ACTIVE',
}

export interface RawTenancyApiUpdateRequest {
  name?: string | null;
  start?: string | null;
  end?: string | null;
  position?: number | null;
  status?: TenancyUpdateStatus;
  custom?: any;
}

export function rawTenancyApiResponseToRawTenancyApiUpdateRequest(
  data: RawTenancyApiResponse,
): RawTenancyApiUpdateRequest {
  return {
    name: data.name,
    start: data.start,
    end: data.end,
    position: data.position,
    status: data.status as unknown as TenancyUpdateStatus,
    custom: data.custom,
  };
}
